export default "assets/images/logo-87e7e4ca.png";